import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Button } from '../ui/button.js';
import { LineIcon } from '../ui/icons/LineIcon.js';
import { cn } from '../../lib/utils.js';

const buttonIconList = {
  more: /* @__PURE__ */ jsx(LineIcon, { icoColor: "bg-icon-primary-04", icoName: "ico-more", type: "xs" }),
  linkBlue: /* @__PURE__ */ jsx(LineIcon, { icoColor: "bg-icon-primary-04", icoName: "ico-caret-right", type: "xs" }),
  redirect: /* @__PURE__ */ jsx(LineIcon, { icoColor: "bg-icon-primary-04", icoName: "ico-redirect", type: "xs" }),
  alert: /* @__PURE__ */ jsx(LineIcon, { icoColor: "bg-icon-primary-04", icoName: "ico-alert", type: "xs" }),
  plus: /* @__PURE__ */ jsx(LineIcon, { icoColor: "bg-icon-primary-04", icoName: "ico-plus", type: "xs" }),
  search: /* @__PURE__ */ jsx(LineIcon, { icoColor: "bg-icon-primary-04", icoName: "ico-search", type: "xs" }),
  timer: /* @__PURE__ */ jsx(LineIcon, { icoColor: "bg-icon-primary-04", icoName: "ico-timer", type: "xs" }),
  filter: /* @__PURE__ */ jsx(LineIcon, { icoColor: "bg-icon-primary-04", icoName: "ico-filter", type: "xs" })
};
const ButtonWithIcon = forwardRef(({
  title,
  size = "medium",
  icon,
  customIcon,
  direction = "left",
  className,
  ...props
}, ref) => {
  const IconComponent = customIcon || buttonIconList[icon];
  return /* @__PURE__ */ jsxs(Button, { variant: "ghost", ...props, className: cn("p-0 h-auto", className), ref, children: [
    direction === "left" && IconComponent && IconComponent,
    /* @__PURE__ */ jsx("span", { className: cn(size === "small" ? "body-md" : "body-lg font-weight-medium"), children: title }),
    direction === "right" && IconComponent && IconComponent
  ] });
});

export { ButtonWithIcon };
